import { render, staticRenderFns } from "./PackageProviderList.vue?vue&type=template&id=48d79226"
import script from "./PackageProviderList.vue?vue&type=script&lang=js"
export * from "./PackageProviderList.vue?vue&type=script&lang=js"
import style0 from "./PackageProviderList.vue?vue&type=style&index=0&id=48d79226&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports